import { graphql } from 'react-apollo';
import { get } from 'lodash';
import { getQuestionsTypesOnAssignment } from 'legacy/src/queries';
import { getEducationPeriodForSubject } from 'chameleon-src/components/auth/utils';

export default graphql(getQuestionsTypesOnAssignment, {
  options: (props) => {
    const { params, userData, assignment } = props;
    const assignmentId =
      get(assignment, 'id') ||
      get(assignment, 'assignment_id', params.assignmentId);
    return {
      fetchPolicy: 'network-only',
      variables: {
        assignmentId,
        educationPeriod: getEducationPeriodForSubject({
          subjectId: params.subject.toString(),
          userData,
        }),
      },
    };
  },
  /**
   * Skip condition added to allow the component using this GQL call
   * to decide in what instances we can allow it to be skipped. It was
   * primarily added for the GenerateAnswerSheetModal component which will sometimes
   * have it's required props passed to it, but in other cases can act as a self-contained
   * component fetching the props it requires from this endpoint.
   */
  skip: ({ skipQuestionTypeQuery = false }) => skipQuestionTypeQuery,
  props: ({ data: { assignment, error, loading } }) => {
    if (error && !assignment) {
      return {
        error: error.message,
      };
    }

    if (loading) {
      return {
        isGraphQLLoading: loading,
      };
    }

    const assignmentInfo = assignment;
    const {
      questions,
      window,
      timezone,
      isReviewDisabled,
      assignmentPaperscorerAnswerSheet,
    } = assignment || {};
    const { startDate, endDate } = window || {};

    const assignmentQuestionTypes = questions
      ? questions.reduce((acc, question) => {
          const questionTypesMap = {
            FreeResponseQuestion: 'all-frq',
            MultipleChoiceQuestion: 'all-mcq',
          };

          const questionType =
            acc !== 'none' ? questionTypesMap[question.type] : 'none';

          if (questionType !== 'none' && questionType !== acc) {
            return 'mixed';
          }

          return questionTypesMap[question.type];
        }, 'none')
      : {};

    return {
      timezone,
      assignmentQuestionTypes,
      startDate,
      endDate,
      isReviewDisabled,
      assignmentPaperscorerAnswerSheet,
      questions,
      assignmentInfo,
      isGraphQLLoading: loading,
    };
  },
});
